import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { MaintenanceComponent } from './common/components/maintenance/maintenance.component';
import { SplashComponent } from './common/components/splash/splash.component';
import { ToastComponent } from './common/components/toast/toast.component';
import { AuthService } from './common/services/auth.service';
import { ScreenService } from './common/services/screen.service';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, ToastComponent, SplashComponent, MaintenanceComponent],
	templateUrl: './app.component.html',
})
export class AppComponent {
	public auth = inject(AuthService);
	public screen = inject(ScreenService);

	public maintenanceMode = environment.appMeta.maintenanceMode;

	constructor() {
		// Apply screen breakpoints classes that can be accessed in components using e.g. `:host-context(.screen-s)`
		effect(() => {
			document.body.classList.toggle('screen-s', this.screen.small());
			document.body.classList.toggle('screen-xs', this.screen.extraSmall());
			document.body.classList.toggle('screen-m', this.screen.medium());
		});
	}
}
